/**
 * Height of the fixed top navbar in pixels.
 * Used by TopNavBar (spacer div) and SideBar (sticky offset + height calc).
 * Update here if the navbar height ever changes.
 */
export const NAVBAR_HEIGHT = 64;

/**
 * z-index for the fixed top navbar.
 *
 * Before v3 the DS `Navbar` (position="fixed") owned its own stacking, so the
 * app never set this. The v3 `TopNav` isn't positioned, so we pin it in a plain
 * fixed layer and must supply the z-index ourselves.
 *
 * Sits above app chrome — the SideBar (z-index 20) and its office switcher
 * (z-index 1000) — so the pinned header always paints over page content. It
 * stays *below* full-screen modal overlays (MODAL_OVERLAY_Z_INDEX = 9999), so
 * modal backdrops still dim and cover the header exactly as before — no clash.
 */
export const NAVBAR_Z_INDEX = 1100;

/**
 * z-index for full-screen modal overlays / backdrops.
 *
 * Must sit above all app chrome — notably the SideBar (z-index 20, raised in
 * GOTU-4041 so page headers tuck under it) and its office switcher (z-index
 * 1000). Any overlay below this renders *behind* the sidebar, leaving it bright
 * and clickable through the dim backdrop.
 *
 * Keep the `.modal` class in `themes/registration.scss` in sync with this value.
 */
export const MODAL_OVERLAY_Z_INDEX = 9999;
